/* eslint-disable import/no-cycle */
import api from './api.service';

function login(email, password) {
  return api.post('/auth/login', {
    email,
    password,
  });
}

function logout() {
  return api.delete('/auth/logout');
}

export const authService = {
  login,
  logout,
};
